// src/utils/mappers/tagMappers.ts
import { Tag, DbTag, TagCreate, TagUpdate, DbTagInsert, DbTagUpdate } from '@/types/entities/tag';

/**
 * Маппер из DbTag в Tag (snake_case -> camelCase)
 */
export const dbTagToTag = (dbTag: DbTag): Tag => ({
  id: dbTag.id,
  userId: dbTag.user_id,
  name: dbTag.name,
  parentId: dbTag.parent_id === null || dbTag.parent_id === 'null' ? null : dbTag.parent_id,
  color: dbTag.color === null || dbTag.color === 'null' ? null : dbTag.color,
  description: dbTag.description === null || dbTag.description === 'null' ? null : dbTag.description,
  type: dbTag.type,
  order: dbTag.order,
  createdAt: new Date(dbTag.created_at),
  updatedAt: new Date(dbTag.updated_at),
});

/**
 * Маппер из TagCreate в DbTagInsert (camelCase -> snake_case)
 */
export const tagCreateToDbTagInsert = (tagCreate: TagCreate, userId: string, order?: number): DbTagInsert => {
  const base: Partial<DbTag> = {
    user_id: userId,
    name: tagCreate.name,
    parent_id: tagCreate.parentId === 'null' ? null : tagCreate.parentId,
    color: tagCreate.color === 'null' ? null : tagCreate.color,
    description: tagCreate.description === 'null' ? null : tagCreate.description,
    type: tagCreate.type,
  };
  if (order !== undefined) {
    (base as DbTag).order = order;
  }
  // DbTagInsert is DbTag without id/created_at/updated_at; cast after conditional build
  return base as DbTagInsert;
};

/**
 * Маппер из TagUpdate в DbTagUpdate (camelCase -> snake_case)
 */
export const tagUpdateToDbTagUpdate = (tagUpdate: TagUpdate): DbTagUpdate => {
  const dbUpdate: DbTagUpdate = {};
  
  if (tagUpdate.name !== undefined) dbUpdate.name = tagUpdate.name;
  if (tagUpdate.parentId !== undefined) dbUpdate.parent_id = tagUpdate.parentId === 'null' ? null : tagUpdate.parentId;
  if (tagUpdate.color !== undefined) dbUpdate.color = tagUpdate.color === 'null' ? null : tagUpdate.color;
  if (tagUpdate.description !== undefined) dbUpdate.description = tagUpdate.description === 'null' ? null : tagUpdate.description;
  if (tagUpdate.type !== undefined) dbUpdate.type = tagUpdate.type;
  if (tagUpdate.order !== undefined) dbUpdate.order = tagUpdate.order;
  
  return dbUpdate;
};

/**
 * Утилита для подготовки данных тега для базы данных
 */
export const prepareTagForDb = (tag: Partial<Tag>): Partial<DbTag> => {
  const dbTag: Partial<DbTag> = {};
  
  if (tag.name !== undefined) dbTag.name = tag.name;
  if (tag.parentId !== undefined) dbTag.parent_id = tag.parentId === 'null' ? null : tag.parentId;
  if (tag.color !== undefined) dbTag.color = tag.color === 'null' ? null : tag.color;
  if (tag.description !== undefined) dbTag.description = tag.description === 'null' ? null : tag.description;
  if (tag.type !== undefined) dbTag.type = tag.type;
  if (tag.order !== undefined) dbTag.order = tag.order;
  if (tag.userId !== undefined) dbTag.user_id = tag.userId;
  
  return dbTag;
};
